require("core-js/modules/es6.object.define-property.js");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = e || self)["@tinacms/media"] = {});
}(this, function (e) {
  "use strict";

  function t(e) {
    this.store = e;
  }

  e.MediaManager = t, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});